import { IconButton, Stack, Typography } from "@mui/material";
import { PauseIcon } from "@/components/common/icons";
import IconCircleContainer from "@/components/common/icons/containers/iconCircleContainer";
import { GREY, TEXT_SECONDARY, VIOLET } from "@/config/mui/colorPalette";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";

type ClockedInWorkShiftsTrackerProps = {
  shiftDurationSeconds: number | undefined;
  showAdditionalInfo: boolean;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function ClockedInWorkShiftsTracker({
  shiftDurationSeconds,
  showAdditionalInfo,
  handleClick,
}: ClockedInWorkShiftsTrackerProps) {
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  const totalSeconds = Math.floor((shiftDurationSeconds ?? 0) % 60);
  const totalMinutes = Math.floor(((shiftDurationSeconds ?? 0) / 60) % 60);
  const totalHours = Math.floor((shiftDurationSeconds ?? 0) / 60 / 60);

  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
      {showAdditionalInfo && (
        <>
          <Typography variant="paragraphSmall" color={TEXT_SECONDARY} noWrap>
            Work
          </Typography>
          <span style={{ color: GREY[40] }}>•</span>
          {shiftDurationSeconds !== undefined && (
            <Typography variant="labelSmall">
              {totalHours}:{totalMinutes.toString().padStart(2, "0")}:
              {totalSeconds.toString().padStart(2, "0")}
            </Typography>
          )}
        </>
      )}
      <IconButton
        onClick={handleClick}
        disableRipple
        sx={{
          padding: "2px !important",
          mx: "6px",
          "&:hover": {
            backgroundColor: isMobile ? VIOLET[80] : VIOLET[20],
          },
        }}
      >
        <IconCircleContainer
          color={VIOLET[40]}
          size="32px"
          icon={<PauseIcon size={18} color={VIOLET[80]} />}
        />
      </IconButton>
    </Stack>
  );
}
